import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngxs/store';
import { GetBorrowerDocuments, UploadDocument } from 'app/store/documents/document.actions';
import { fileTypesAccepted } from 'app/models/const/fileTypesAccepted';
import { Document } from 'app/models/dto/document.model';
import { lastValueFrom, Observable } from 'rxjs';
import { DocumentState } from 'app/store/documents/document.state';
import { Alert } from 'app/models/dto/alert.model';

@Component({
  selector: 'app-document-picker',
  templateUrl: './document-picker.component.html',
  styleUrls: ['./document-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DocumentPickerComponent implements OnInit {
  @Input() borrowerId: number;
  @Output() documentChange = new EventEmitter<Document>();
  @Output() documentError = new EventEmitter<Alert>();

  loading = false;
  typesAccepted: any;
  documents$: Observable<Document[]>;

  constructor(
    private store: Store,
    private cdRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.store.dispatch(new GetBorrowerDocuments(this.borrowerId));
    this.documents$ = this.store.select(DocumentState.documents);
    this.typesAccepted = fileTypesAccepted;
  }

  handleUpload(file: File) {
    if (!file) {
      return;
    }
    this.loading = true;
    this.cdRef.markForCheck();
    lastValueFrom(this.store
      .dispatch(new UploadDocument(
        file,
        this.borrowerId,
        document => this.documentChange.emit(document),
      )))
      .then(() => {
        this.loading = false;
        this.cdRef.markForCheck();
      });
  }

  handleSelect(document: Document) {
    this.documentChange.emit(document);
  }
}
